module.exports = __webpack_public_path__ + "static/media/payments-b.99b0be41.svg";